import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class AddJobs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: "",
      userName: "",
      title: "",
      category: "",
      areaInput: "",
      categoryData: [],
      submissionStatus: null,
      currentImageUrl: null,
      submeet: false,
      errors: [],
      city: "",
      salary: "",
      date: '',
      isDateValid: true,
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
      companyName: "",
      address: "",
      pincode: ""
    };
  }

  async componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/occupation`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        this.setState({ categoryData: response.data.categories });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    files.forEach((file) => {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
        });
      }
    });

    this.setState({ errors });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submeet: true });

    const { textInput, date, city, salary, title, areaInput, category, companyName, address, pincode } = this.state;

    // if (!textInput || !userName || !title || !areaInput || !category) {
    //   return;
    // }

    try {
      console.log("3");
      const formData = new FormData();
      formData.append('image', textInput);
      formData.append('title', title);
      formData.append('description', areaInput);
      formData.append('salary', salary);
      formData.append('category', category);
      formData.append('companyName', companyName);
      formData.append('address', address);
      formData.append('pincode', pincode);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      };
      console.log("1");

      const response = await axios.post("https://samaj.aasmo.in/api/admin/jobs", formData, config);

      if (response.status === 201) {
        console.log("2");
        this.setState({ submissionStatus: 'success', submeet: false });
        setTimeout(() => {
          this.props.history.push ("/jobslist");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };

  render() {
    const { textInput, isDateValid, date, title, currentImageUrl, city, salary, userName, category, categoryData, submeet, areaInput, submissionStatus, companyName, address, pincode } = this.state;
    const isNameValid = userName.trim().length > 0;
    const isTitleValid = title.trim().length > 0;
    const isCityValid = city?.trim().length > 0;
    const isSalaryValid = salary?.trim().length > 0;
    const isCompanyNameValid = companyName.trim().length > 0;
    const isAddressValid = address.trim().length > 0;
    const isPincodeValid = pincode.trim().length > 0;

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Add Job</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label htmlFor="bloodGroup">Category</label>
                <select
                  className={`form-control ${submeet && !category && "parsley-error"}`}
                  value={category}
                  name="category"
                  required=""
                  onChange={(e) => {
                    this.setState({ category: e.target.value });
                  }}
                >
                  <option value="">Select Category</option>
                  {categoryData && categoryData.map((key) => (
                    <option key={key._id} value={key._id}>{key.name}</option>
                  ))}
                </select>
                {submeet && !category ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Category is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Title</label>
                <input
                  className={`form-control ${!isTitleValid && submeet && "parsley-error"}`}
                  value={title}
                  name="title"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ title: e.target.value });
                  }}
                />
                {!isTitleValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Image</label>
                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control ${!textInput && submeet && "parsley-error"}`}
                  name="textInput"
                  required=""
                  onChange={this.handleChange}
                />
                {!textInput && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Salary</label>
                <input
                  className={`form-control ${!isSalaryValid && submeet && "parsley-error"}`}
                  value={salary}
                  name="salary"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ salary: e.target.value });
                  }}
                />
                {!isSalaryValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Company Name</label>
                <input
                  className={`form-control ${!isCompanyNameValid && submeet && "parsley-error"}`}
                  value={companyName}
                  name="companyName"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ companyName: e.target.value });
                  }}
                />
                {!isCompanyNameValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Address</label>
                <input
                  className={`form-control ${!isAddressValid && submeet && "parsley-error"}`}
                  value={address}
                  name="address"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ address: e.target.value });
                  }}
                />
                {!isAddressValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Pincode</label>
                <input
                  className={`form-control ${!isPincodeValid && submeet && "parsley-error"}`}
                  value={pincode}
                  name="pincode"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ pincode: e.target.value });
                  }}
                />
                {!isPincodeValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea
                  className={`form-control ${areaInput === "" && submeet && "parsley-error"}`}
                  value={areaInput}
                  cols="30"
                  name="textarea"
                  required=""
                  rows="5"
                  onChange={(e) => {
                    this.setState({ areaInput: e.target.value });
                  }}
                ></textarea>
                {areaInput === "" && submeet ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>
              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}
              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(connect(mapStateToProps, { notifyGeneralInfo })(AddJobs));
